import { Instant, LocalDate, LocalTime, LocalDateTime, Duration } from "@js-joda/core";

export enum PhotoGsd {
    R7p5CM = 0,
    R15CM = 1,
    R30CM = 2,
}

export enum AbandonedVehicleReviewStatus {
    New = 10,
    NotActionable = 20,
    Actionable = 30,
}

export enum AbandonedVehicleStatus {
    Candidate = 10,
    ReviewedUnsure = 15,
    ReviewedVerified = 20,
    ReviewedRejected = 30,
    ReviewedRejectedIdentity = 33,
    ReviewedRejectedMoved = 36,
    ReviewedRejectedDeparted = 37,
    ReviewedRejectedArrived = 38,
    ReviewedRejectedNotAVehicle = 39,
    InPersonUnsure = 40,
    InPersonVerified = 45,
    InPersonRejected = 50,
    Impounded = 60,
    Released = 65,
    Scrapped = 70,
}

export enum PasswordResetType {
    Initial = 0,
    Forgot = 1,
}

export enum VehicleSituation {
    Street = 10,
    Shoulder = 20,
    Sidewalk = 30,
    Field = 40,
    Alleyway = 50,
    Driveway = 60,
    ParkingLot = 70,
    Junkyard = 80,
    Worksite = 90,
    Industrial = 100,
}
export interface AerialImageApi {
    aerialImageId: number;
    aerialProviderId: number;
    name: string;
    filePath: string;
    fileSize: number;
    contentType: string;
    capturedWhen: string;
    originX: number;
    pixelWidth: number;
    rotationX: number;
    originY: number;
    rotationY: number;
    pixelHeight: number;
    epsgCode: number;
    width: number;
    height: number;
    minX: number;
    minY: number;
    maxX: number;
    maxY: number;
}

export interface AerialImagePairOffsetApi {
    aerialImagePairOffsetId: number;
    aerialImageBeforeId: number;
    aerialImageAfterId: number;
    offsetX: number;
    offsetY: number;
}

export interface AiStructuredResponseApi {
    vehicle: VehicleApi;
    addresses: RepoAddressApi[];
}

export interface CadModelAttributesApi {
    vehicleType: string | null;
}

export interface CadModelApi {
    id: number;
    modelId: string;
    collectionId: string;
    modelName: string | null;
    description: string | null;
    issue: string | null;
    carMake: string | null;
    carYear: string | null;
    carModel: string | null;
    dimsL: number | null;
    dimsW: number | null;
    dimsH: number | null;
    color: string | null;
    domain: string | null;
    type1: string | null;
    url: string | null;
    error: string | null;
    comment: string | null;
    attributes: CadModelAttributesApi;
}

export interface ChicagoAbandonedVehicleApi {
    lat: number | null;
    lng: number | null;
    date: string | null;
}

export interface CreateAerialImageApi {
    fileName: string;
    filePath: string;
    location: string;
    capturedAt: string | null;
    resolution: number;
    width: number;
    height: number;
    fileSize: number;
    tags: string[] | null;
}

export interface DatasetApi {
    datasetId: number;
    name: string;
    description: string | null;
    count: number;
}

export interface DatasetImageApi {
    datasetImageId: number;
    datasetId: number;
    name: string;
    filePath: string;
    width: number;
    height: number;
    objectCount: number;
    annotatedCount: number;
    epsgCode: number | null;
    originX: number | null;
    originY: number | null;
    pixelWidth: number | null;
    pixelHeight: number | null;
    rotationX: number | null;
    rotationY: number | null;
    minX: number | null;
    minY: number | null;
    maxX: number | null;
    maxY: number | null;
}

export interface DatasetStatsApi {
    datasetId: number;
    imageCount: number;
    vehicleCount: number;
    vehicleTypeStats: string[];
    vehicleColorStats: string[];
}

export interface DumpTrainingDataRespApi {
    classCounts: string[];
    total: number;
    errors: number;
}

export interface EmployeeApi {
    employeeId: number;
    municipalityId: number;
    emailAddress: string;
    name: string;
    municipality: MunicipalityApi;
}

export interface LoginResponseApi {
    token: string;
    employee: EmployeeApi;
}

export interface MunicipalityApi {
    municipalityId: number;
    name: string;
}

export interface ObbAnnotationAttributesApi {
    classLabel: number | null;
    vehicleType: string | null;
    color: string | null;
    parts: number[] | null;
    shade: boolean | null;
    occluded: boolean | null;
    rare: boolean | null;
}

export interface ObbAnnotationApi {
    obbAnnotationId: number;
    datasetImageId: number;
    x: number;
    y: number;
    width: number;
    height: number;
    angle: number;
    attributes: ObbAnnotationAttributesApi;
}

export interface ObbClassApi {
    obbClassId: number;
    name: string;
}

export interface ObbDetApi {
    obbDetId: number;
    obbRunId: number;
    obbModelId: number;
    obbClassId: number;
    x: number;
    y: number;
    width: number;
    height: number;
    angle: number;
    confidence: number;
}

export interface ObbDetCompApi {
    id: number;
    cls: number;
    x: number;
    y: number;
    w: number;
    h: number;
    a: number;
    c: number;
}

export interface ObbModelApi {
    obbModelId: number;
    name: string;
}

export interface AbandonedVehicleRunApi {
    abandonedVehicleRunId: number;
    aerialImageBeforeId: number;
    aerialImageAfterId: number;
    before: AerialImageApi;
    after: AerialImageApi;
    createdWhen: string;
}

export interface ObbRunApi {
    obbRunId: number;
    aerialImageId: number;
    obbModelId: number;
    createdByEmployeeId: number;
    createdWhen: string;
    notes: string | null;
}

export interface RepoAddressApi {
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
}

export interface RepoSearchReqApi {
    vehiclePrompt: string;
    addressesPrompt: string;
}

export interface RepoSearchRespApi {
    vehicle: VehicleDataApi;
    addresses: AddressDataApi[];
}

export interface VehicleDataApi {
    make: string;
    model: string;
    color: string | null;
    year: number | null;
}

export interface AddressDataApi {
    streetNumber: string | null;
    street: string | null;
    city: string | null;
    state: string | null;
    postalCode: string | null;
}

export interface DateTestApi {
    when: string;
    when1: string;
    when2: string;
    when3: string;
    dur1: number;
}

export interface ResolvedAddressApi {
    addressId: number;
    fullAddress: string;
    streetNumber: string | null;
    street: string | null;
    city: string | null;
    state: string | null;
    postalCode: string | null;
    country: string | null;
    latitude: number | null;
    longitude: number | null;
    resolvedWhen: string;
}

export interface UpdateAerialImageApi {
    location: string | null;
    processingStatus: string | null;
    tags: string[] | null;
}

export interface VehicleApi {
    vehicleId: number;
    make: string;
    model: string;
    color: string | null;
    year: number | null;
}

export interface AbandonedVehicleApi {
    abandonedVehicleId: number;
    x: number;
    y: number;
    width: number;
    height: number;
    angle: number;
    confidence: number;
    similarity: number;
    status: AbandonedVehicleChangeApi;
    reviewStatus: AbandonedVehicleReviewChangeApi | null;
    note: string;
    attributes: AbandonedVehicleAttributesApi;
    changes: AbandonedVehicleChangeApi[];
    reviews: AbandonedVehicleReviewChangeApi[];
}

export interface AbandonedVehicleAttributesApi {
    landUse: number | null;
    vehicleType: number | null;
    situation: VehicleSituation | null;
    area: number | null;
    address: string | null;
}

export interface AbandonedVehicleAttributesCompressedApi {
    lu: number | null;
    vt: number | null;
    si: VehicleSituation | null;
    ar: number | null;
    ad: string | null;
}

export interface AbandonedVehicleChangeApi {
    abandonedVehicleChangeId: number;
    abandonedVehicleId: number;
    note: string;
    status: AbandonedVehicleStatus;
    createdWhen: string;
    createdBy: EmployeeApi | null;
}

export interface AbandonedVehicleChangeCompressedApi {
    c: AbandonedVehicleStatus;
    d: string;
}

export interface AbandonedVehicleCompressedApi {
    a: number;
    x: number;
    y: number;
    w: number;
    h: number;
    t: number;
    c: number;
    s: number;
    at: AbandonedVehicleAttributesCompressedApi;
    st: AbandonedVehicleChangeCompressedApi;
    rs: AbandonedVehicleReviewChangeCompressedApi | null;
}

export interface AbandonedVehicleReviewChangeApi {
    abandonedVehicleReviewChangeId: number;
    abandonedVehicleId: number;
    note: string;
    status: AbandonedVehicleReviewStatus;
    createdWhen: string;
    createdBy: EmployeeApi;
}

export interface AbandonedVehicleReviewChangeCompressedApi {
    c: AbandonedVehicleReviewStatus;
    d: string;
}

export interface AbandonedVehicleUpdateReqApi {
    note: string;
    status: AbandonedVehicleStatus;
}

export interface AbandonedVehicleReviewUpdateReqApi {
    note: string;
    status: AbandonedVehicleReviewStatus;
}

export interface AbandonedVehicleUpdateAttrReqApi {
    situation: VehicleSituation | null;
}

export interface AbandonedVehicleCreateReqApi {
    runId: number;
    x: number;
    y: number;
    width: number;
    height: number;
    angle: number;
}

export interface LoginReqApi {
    emailAddress: string;
    password: string;
}

export interface RegisterReqApi {
    businessId: number;
    emailAddress: string;
    name: string;
    password: string;
    note: string;
}

export interface ForgotPasswordReqApi {
    emailAddress: string;
}

export interface ResetPasswordReqApi {
    email: string;
    resetCode: string;
    newPassword: string;
}

export interface ChangePasswordReqApi {
    currentPassword: string;
    newPassword: string;
}

export interface ChangeEmailReqApi {
    currentPassword: string;
    newEmailAddress: string;
}

export interface ChangeNameReqApi {
    name: string;
}

export interface LoginRespApi {
    token: string;
    employee: EmployeeApi;
}

export interface ResetPasswordCheckReqApi {
    resetCode: string;
}

export interface CadModelUpdateAttributesReqApi {
    attributes: CadModelAttributesApi;
}

export interface DatasetCreateReqApi {
    name: string;
    description: string | null;
}

export interface DatasetRespApi {
    datasetId: number;
    name: string;
    description: string | null;
}

export interface DatasetImageAddRespApi {
    datasetImageId: number;
}

export interface DatasetImageObjectAddReqApi {
    x: number;
    y: number;
    width: number;
    height: number;
    angle: number;
    attributes: ObbAnnotationAttributesApi;
}

export interface TileAerialImageReqApi {
    aerialImageId: number;
    datasetName: string;
    tileSize: number;
    overlapPercentage: number;
}

export interface TleRecApi {
    twoLineElementId: number;
    satelliteId: number;
    noradCatId: number;
    epoch: string;
    line1: string;
    line2: string;
}

export interface SatelliteInfoApi {
    satelliteId: number;
    noradCatId: number;
    name: string;
}

export interface TleReqApi {
    noradCatIds: number[];
}

export interface TileResponseApi {
    message: string;
    tilesGenerated: number;
    tilesSkipped: number;
    outputPath: string;
    zoomLevels: number;
    minZoom: number;
    maxZoom: number;
    imageWidth: number;
    imageHeight: number;
}
